import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import constant from 'constant';
import { API, setHeader, setCookieAuthenticate, initHeader } from 'common';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Select from 'react-select';
import Cookies from 'js-cookie';
import phoneIcon from 'assets/svg/ic_phone.svg';
// import { Capacitor } from '@capacitor/core';
// import { Keyboard } from '@capacitor/keyboard';
// reactstrap components
import {
	Button,
	FormGroup,
	Form,
	InputGroupText,
	InputGroup,
	FormFeedback,
	Modal,
	ModalBody,
} from 'reactstrap';
import type { Salon } from 'types/models';

// The OTP field below has never passed react-input-mask's required `mask`
// prop; kept loosely typed rather than adding one.
const InputMaskLoose: React.ComponentType<any> = InputMask;

interface SignInProps extends RouteComponentProps {
	loginState: boolean;
	setLogin: (value: boolean) => void;
}

const PhoneIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<g transform="translate(5, 1)" fill="#DFE2E6" fillRule="nonzero">
			<path d="M11,0 L3,0 C1.62,0 0.5,1.12 0.5,2.5 L0.5,19.5 C0.5,20.88 1.62,22 3,22 L11,22 C12.38,22 13.5,20.88 13.5,19.5 L13.5,2.5 C13.5,1.12 12.38,0 11,0 Z M7,21 C6.17,21 5.5,20.33 5.5,19.5 C5.5,18.67 6.17,18 7,18 C7.83,18 8.5,18.67 8.5,19.5 C8.5,20.33 7.83,21 7,21 Z M11.5,17 L2.5,17 L2.5,3 L11.5,3 L11.5,17 Z" />
		</g>
	</svg>
);

export default withRouter(function SignIn({
	loginState,
	setLogin,
	history,
	location,
}: SignInProps) {
	const { handleSubmit, control, formState: { errors }, setError } = useForm();
	const [phoneVerify, setPhoneVerify] = useState(false);
	const [phone, setPhone] = useState<string | null>(null);
	const [openSalon, setOpenSalon] = useState(false);
	const [staffId, setStaffId] = useState<number | null>(null);
	const [dataSalon, setDataSalon] = useState<Salon[]>([]);
	const [salon, setSalon] = useState<Salon | null>(null);
	const [statusLogin, setStatusLogin] = useState(0);
	const [disableSubmit, setDisableSubmit] = useState(false);

	const onSubmit = async (data: any) => {
		setDisableSubmit(true);
		switch (statusLogin) {
			case 0:
				try {
					let unmaskphone = data.phone.replace(/[^\d]/g, '');
					setPhone(unmaskphone);
					let sign_in_response = await API.get(`staff/sign-in-by-phone/${unmaskphone}`);
					if (sign_in_response.status === 200) {
						let { payload } = sign_in_response.data;
						if (payload.length > 0) {
							setSalon(payload[0]);
							setDataSalon(payload);
							setOpenSalon(true);
							setStatusLogin(1);
						}
						else {
							setError('phone', { type: 'error_phone' });
						}
					}
				} catch (error) {
					setError('phone', { type: 'error_phone' });
				}
				break;
			case 1:
				try {
					let response = await API.post('staff/generateOtp', {
						payload: {
							phone: phone,
							shopId: salon!.id
						},
					});
					// console.log(unmaskphone);
					if (response.status === 200) {
						let { payload } = response.data;
						setStaffId(payload.staffId);
						// open popup verify
						setPhoneVerify(!phoneVerify);
						// change status login: verify OTP
						setStatusLogin(2);
					}
					else {
						setError('salon', { type: 'get_otp_fail' });
					}

				} catch (error) {
				}
				break;
			case 2:
				try {
					let otp = data.otp;
					let response = await API.post('staff/verifyOtp', {
						payload: {
							staffId: staffId,
							verifyCode: otp,
							shopId: salon!.id
						},
					});
					if (response.status === 200) {
						const { payload } = response.data;
						// console.log(payload);
						if (payload != 0) {
							setHeader(salon!.apiKey);

							let staff = payload.staff;
							setCookieAuthenticate(
								// staffId is numeric here; setCookieAuthenticate's `value` param is
								// typed as string but this call has always passed the raw id through.
								staffId as any,
								parseInt(process.env.REACT_APP_EXPIRES_COOKIE!)
							);
							// check is staff or manager
							var is_manager = 0;
							if (staff.positionName && staff.positionName === 'Admin') {
								is_manager = 1;
							}
							Cookies.set(process.env.REACT_APP_COOKIE_KEY_PHONE!, phone!, { expires: parseInt(process.env.REACT_APP_EXPIRES_COOKIE!) });
							// js-cookie's `value` param is typed as string; is_manager and staffId are
							// numeric here as they always have been.
							Cookies.set(process.env.REACT_APP_COOKIE_KEY_ISMANAGER!, is_manager as any, { expires: parseInt(process.env.REACT_APP_EXPIRES_COOKIE!) });
							Cookies.set(process.env.REACT_APP_COOKIE_KEY!, staffId as any, { expires: parseInt(process.env.REACT_APP_EXPIRES_COOKIE!) });
							initHeader();
							localStorage.setItem(
								'infor_staff',
								JSON.stringify(staff)
							);
							localStorage.setItem(
								'info_salon',
								JSON.stringify(salon)
							);

							history.replace(is_manager ? '/overview' : '/');
						}
						else {
							setError('otp', { type: 'verify_fail' });
						}
					}
					else {
						setError('otp', { type: 'verify_fail' });
					}
				} catch (error: any) {
					console.log('error', error);
					const { data } = error.response;
					data.code === 1003 && setError('otp', { type: 'verify_fail' });
				}
				break;
			default:
				break;
		}
		setDisableSubmit(false);
	};

	// react-select's onChange type is `SingleValue<T> | null` regardless of
	// `isClearable`; this Select is not clearable so a concrete option is
	// always passed at runtime, but the type must allow for null here.
	const handleChange = (selectedOption: { value: Salon | null; label: string } | null) => {
		setSalon(selectedOption!.value);
		setHeader(selectedOption!.value!.apiKey);
	}
	return (
		<>
			<Modal
				className="fixed-bottom m-0"
				size="lg"
				isOpen={loginState}
				toggle={() => setLogin(true)}
			>
				<ModalBody>
					<h2>Login</h2>
					<p style={{ color: '#2C2C2C' }}>
						Your information
					</p>
					<Form role="form" onSubmit={handleSubmit(onSubmit)}>
					<FormGroup id="form-phone-number">
						<InputGroup className="input-group-alternative">
							<InputGroupText>
								<img
									src={phoneIcon}
									alt="Phone Number"
								/>
							</InputGroupText>
							<Controller
								control={control}
								name="phone"
								defaultValue=""
								rules={{
									required: true,
									pattern: /\([0-9]{3}\) [0-9]{3}-[0-9]{4}/,
								}}
								render={({ field }) => (
									<InputMask
										{...field}
										mask={constant.MASK_PHONE_INPUT}
										className="form-control"
										style={{ color: '#000' }}
										type="tel"
										placeholder="Phone Number"
										disabled={openSalon}
									/>
								)}
							/>
						</InputGroup>
							{errors.phone?.type === 'required' && (
								<FormFeedback>
									Your input is required
								</FormFeedback>
							)}
							{errors.phone?.type === 'pattern' && (
								<FormFeedback>
									Please enter the correct format
								</FormFeedback>
							)}
							{errors.phone?.type === 'error_phone' && (
								<FormFeedback>
									Your phone number does not exists.
								</FormFeedback>
							)}
						</FormGroup>
						{errors.account && (
							<FormFeedback>
								{/* `account` isn't a registered field here; errors.account's inferred
								  type (string | FieldError | ...) isn't guaranteed to be a plain
								  ReactNode, so rendering it is kept loosely typed. */}
								{(errors.account as any).message}
							</FormFeedback>
						)}
						{openSalon ?
						(<FormGroup id="form-salon">
							<p style={{ color: '#2C2C2C' }}>
								Your salon
							</p>
							<Select
								value={{ value: salon, label: salon!.companyName }}
								onChange={handleChange}
								options={dataSalon.map((i) => ({
									value: i,
									label: i.companyName,
								}))}
								className="mb-4 input-group-alternative"
								isSearchable={false}
								placeholder="Salon"
								menuPlacement={'top'}
								styles={{
									control: (base) => ({
										...base,
										height: 46,
										minHeight: 46,
										border: '1px solid #adb5bd',
										color: '#adb5bd',
									}),
								}}
								name="salon"
								isDisabled={phoneVerify}
							/>
							{errors.salon?.type === 'get_otp_fail' && (
								<FormFeedback>
									Get OTP failed!
								</FormFeedback>
							)}
						</FormGroup>
						) : '' }
						{phoneVerify ?
					(<FormGroup id="form-verify">
						<InputGroup className="input-group-alternative">
							<InputGroupText>
								{/* OTP */}
							</InputGroupText>
							<Controller
								control={control}
								name="otp"
								defaultValue=""
								rules={{
									required: true,
								}}
								render={({ field }) => (
									// This OTP input has never passed a `mask` prop (unlike the phone
									// input above); @types/react-input-mask requires one, so it's
									// worked around here instead of adding one.
									<InputMaskLoose
										{...field}
										className="form-control"
										style={{ color: '#000' }}
										type="tel"
										placeholder="OTP"
									/>
								)}
							/>
						</InputGroup>
							{errors.otp?.type === 'required' && (
								<FormFeedback>
									Your OTP is required
								</FormFeedback>
							)}
							{errors.otp?.type === 'verify_fail' && (
								<FormFeedback>
									Your verification code is incorrect
								</FormFeedback>
							)}
						</FormGroup>
						) : '' }
						<div className="text-center">
							<Button
								className="btn btn-block"
								color="primary"
								type="submit"
								disabled={disableSubmit}
							>
								{constant.BTN_LOGIN_LIST[statusLogin]}
							</Button>
						</div>
					</Form>
				</ModalBody>
			</Modal>
		</>
	);
});
